/* ==========================================================================
   One Kickz — scripts propios. Se carga en el <head> ANTES que los scripts del tema.
   ========================================================================== */
(function () {
  var OK_PROT = { variantId: 61516164825228, productId: 10627349676172, optOutKey: 'ok_prot_off' };

  /* Zoom de fotos en la ficha de producto (PhotoSwipe, pellizcar para zoom).
     El tema solo iniciaba el visor desde el carrusel mobile; en desktop ese carrusel
     esta oculto, el visor nunca arrancaba y el clic abria la imagen en otra pestana.
     Solucion: interceptamos la definicion del componente de galeria para
     1) arrancar el visor aunque el carrusel este oculto (una sola vez por pagina) y
     2) que un error en las miniaturas no impida el visor (caso Safari). */
  var started = false;

  /* Al abrir el visor en celular el tema usaba "vFill" (la foto llena todo el alto
     y queda muy ampliada/recortada). Se abre con la foto entera ("fit") y el doble
     toque o el pellizco agranda desde ahi. */
  function patchLightbox() {
    var L = window.PhotoSwipeLightbox;
    if (!L || L.__ok) return;
    var W = function (opts) {
      if (opts && opts.mainClass === 'pswp--product-media-gallery') {
        opts.initialZoomLevel = 'fit';
        opts.secondaryZoomLevel = function (z) { return Math.max(z.fit, Math.min(1, z.fit * 2.5)); };
        opts.maxZoomLevel = function (z) { return Math.max(1, z.fit * 3); };
      }
      return new L(opts);
    };
    W.prototype = L.prototype;
    W.__ok = true;
    window.PhotoSwipeLightbox = W;
  }

  function startLightbox(ctx, proto) {
    if (started) return;
    if (typeof window.PhotoSwipeLightbox === 'undefined' || typeof window.PhotoSwipe === 'undefined') return;
    patchLightbox();
    started = true;
    try {
      proto.__okOrigPswp.call(ctx);
    } catch (e) {
      started = false;
      console.warn('[OK] PhotoSwipe', e);
    }
  }

  var origDefine = customElements.define.bind(customElements);
  customElements.define = function (name, cls, opts) {
    if (name === 'swiper-product-gallery' && cls && cls.prototype && cls.prototype.photoSwipeLightboxInit) {
      var P = cls.prototype;
      P.__okOrigPswp = P.photoSwipeLightboxInit;
      P.photoSwipeLightboxInit = function () { startLightbox(this, P); };

      var origThumbs = P.setThumbsInteraction;
      P.setThumbsInteraction = function () {
        try { return origThumbs.apply(this, arguments); } catch (e) { console.warn('[OK] thumbs', e); }
      };

      var origInit = P.init;
      P.init = function () {
        if (this.hasAttribute('zoom')) startLightbox(this, P);
        return origInit.apply(this, arguments);
      };
      window.__okGalleryProto = P;
    }
    /* Selector de orden: si ninguna opcion viene marcada (p. ej. orden no previsto),
       marcar la primera para que el menu no falle y desaparezca. */
    if (name === 'custom-select' && cls && cls.prototype && cls.prototype.createCustomSelect) {
      var origCreate = cls.prototype.createCustomSelect;
      cls.prototype.createCustomSelect = function () {
        var sel = this.selectEl || this.querySelector('select');
        if (sel && !sel.querySelector('option[selected="selected"]') && sel.options.length) {
          var opt = sel.options[sel.selectedIndex > -1 ? sel.selectedIndex : 0];
          opt.setAttribute('selected', 'selected');
        }
        return origCreate.apply(this, arguments);
      };
    }
    /* Recomendaciones del carrito: el tema usa el primer item del carrito; si es la
       proteccion de envio, usar el primer producto real. */
    if (name === 'product-recommendations' && cls && cls.prototype && cls.prototype.connectedCallback) {
      var origConn = cls.prototype.connectedCallback;
      cls.prototype.connectedCallback = function () {
        try {
          var u = this.dataset && this.dataset.url;
          if (u && window.__okFirstRealPid && u.indexOf('product_id=' + OK_PROT.productId) !== -1) {
            this.dataset.url = u.replace('product_id=' + OK_PROT.productId, 'product_id=' + window.__okFirstRealPid);
          }
        } catch (e) {}
        return origConn.apply(this, arguments);
      };
    }
    return origDefine(name, cls, opts);
  };

  /* Red de seguridad: productos con una sola foto (sin carrusel) o scripts que
     cargaron en otro orden. */
  function fallback() {
    if (started) return;
    var link = document.querySelector('a.product__gallery-toggle');
    var P = window.__okGalleryProto;
    if (!link || !P) return;
    if (!link.closest('.photoswipe-wrapper')) {
      var wrap = link.closest('.main-product__media--grid-item, .main-product__media') || link.parentElement;
      wrap.classList.add('photoswipe-wrapper');
    }
    startLightbox(link.closest('.photoswipe-wrapper') || document.body, P);
  }
  document.addEventListener('DOMContentLoaded', fallback);
  window.addEventListener('load', fallback);

  /* ==========================================================================
     Proteger mi envio (gratis, tildado por defecto)
     - Producto oculto "Proteccion de envio" (USD 0) que se agrega/quita del carrito.
     - Se agrega solo cuando hay productos; si el cliente lo destilda, no se vuelve
       a agregar en esta visita. Se quita solo si el carrito queda sin productos.
     - La linea se oculta del carrito (CSS) y no suma en los contadores.
     ========================================================================== */
  var protBusy = false, protTimer = null;

  function optedOut() { try { return sessionStorage.getItem(OK_PROT.optOutKey) === '1'; } catch (e) { return false; } }
  function setOptOut(v) { try { v ? sessionStorage.setItem(OK_PROT.optOutKey, '1') : sessionStorage.removeItem(OK_PROT.optOutKey); } catch (e) {} }
  function isProt(i) { return i && Number(i.variant_id) === OK_PROT.variantId; }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function remember(cart) {
    var real = (cart.items || []).filter(function (i) { return !isProt(i); });
    window.__okFirstRealPid = real.length ? real[0].product_id : null;
    window.__okCart = cart;
    return real;
  }

  function sectionsParam() {
    var d = document.querySelector('cart-drawer');
    try { return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.section; }) : []; } catch (e) { return []; }
  }

  function render(json) {
    var d = document.querySelector('cart-drawer');
    if (d && d.renderContents && json && json.sections) {
      try { d.renderContents(json, false); } catch (e) { console.warn('[OK] render', e); }
    }
    if (typeof window.updateFreeShipping === 'function') { try { window.updateFreeShipping(); } catch (e) {} }
    fixCounters();
  }

  function cartPost(url, body) {
    var s = sectionsParam();
    if (s.length) { body.sections = s; body.sections_url = window.location.pathname; }
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); });
  }

  function addProt() {
    return cartPost('/cart/add.js', { items: [{ id: OK_PROT.variantId, quantity: 1, properties: { _proteccion: 'gratis' } }] }).then(render);
  }
  function setProtQty(line, qty) {
    return cartPost('/cart/change.js', { id: line.key, quantity: qty }).then(render);
  }

  function ensureProtection() {
    if (protBusy) return Promise.resolve();
    protBusy = true;
    return getCart().then(function (cart) {
      var real = remember(cart);
      var line = (cart.items || []).filter(isProt)[0];
      if (!real.length && line) return setProtQty(line, 0);
      if (real.length && line && line.quantity !== 1) return setProtQty(line, 1);
      if (real.length && !line && !optedOut()) return addProt();
      decorate(cart);
    }).catch(function (e) { console.warn('[OK] proteccion', e); })
      .then(function () { protBusy = false; });
  }

  function scheduleEnsure() {
    clearTimeout(protTimer);
    protTimer = setTimeout(ensureProtection, 150);
  }

  var SHIELD = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 2.5l7.5 2.8v5.5c0 4.7-3.2 8.8-7.5 10.2-4.3-1.4-7.5-5.5-7.5-10.2V5.3L12 2.5z" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/><path d="M8.8 12.2l2.2 2.2 4.2-4.4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function rowHTML(checked) {
    return '<label class="ok-prot" data-ok-prot>' +
      '<input type="checkbox" class="ok-prot__check" data-ok-prot-toggle' + (checked ? ' checked' : '') + '>' +
      '<span class="ok-prot__icon">' + SHIELD + '</span>' +
      '<span class="ok-prot__text">Proteger mi envío<span class="ok-prot__sub">Ante pérdida, robo o daño</span></span>' +
      '<b class="ok-prot__price">GRATIS</b></label>';
  }

  function decorate(cart) {
    cart = cart || window.__okCart;
    if (!cart) return;
    var hasReal = (cart.items || []).some(function (i) { return !isProt(i); });
    var checked = (cart.items || []).some(isProt);
    var targets = [];
    var drawerSummary = document.querySelector('#CartDrawer-Body .cart-drawer__summary');
    if (drawerSummary) targets.push(drawerSummary);
    var pageSummary = document.querySelector('.cart__summary#cart-summary, #main-cart-items ~ * #cart-summary, .cart__summary');
    if (pageSummary && pageSummary !== drawerSummary && !pageSummary.closest('#CartDrawer-Body')) targets.push(pageSummary);
    targets.forEach(function (t) {
      var existing = t.parentElement.querySelector(':scope > [data-ok-prot]') || (t.previousElementSibling && t.previousElementSibling.matches('[data-ok-prot]') ? t.previousElementSibling : null);
      if (!hasReal) { if (existing) existing.remove(); return; }
      if (existing) {
        var cb = existing.querySelector('input');
        if (cb && !cb.disabled) cb.checked = checked;
        return;
      }
      t.insertAdjacentHTML('beforebegin', rowHTML(checked));
    });
    fixCounters(cart);
  }

  function fixCounters(cart) {
    cart = cart || window.__okCart;
    if (!cart) return;
    var n = (cart.items || []).reduce(function (s, i) { return isProt(i) ? s : s + i.quantity; }, 0);
    document.querySelectorAll('.cart-count-badge').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('hidden', n === 0);
    });
    document.querySelectorAll('.cart-drawer__title-counter, .cart__title-counter').forEach(function (el) { el.textContent = n; });
  }

  document.addEventListener('change', function (e) {
    var cb = e.target && e.target.closest && e.target.closest('[data-ok-prot-toggle]');
    if (!cb || protBusy) return;
    e.stopPropagation();
    var want = cb.checked;
    cb.disabled = true;
    protBusy = true;
    setOptOut(!want);
    getCart().then(function (cart) {
      remember(cart);
      var line = (cart.items || []).filter(isProt)[0];
      if (want && !line) return addProt();
      if (!want && line) return setProtQty(line, 0);
    }).catch(function () { cb.checked = !want; })
      .then(function () { protBusy = false; cb.disabled = false; getCart().then(function (c) { remember(c); decorate(c); }); });
  }, true);

  function watchCart() {
    // Contadores: reemplazar la funcion del tema para que no cuente la proteccion.
    if (typeof window.updateCartCounters === 'function' && !window.updateCartCounters.__ok) {
      var okCounters = function () { return getCart().then(function (c) { remember(c); fixCounters(c); }); };
      okCounters.__ok = true;
      window.updateCartCounters = okCounters;
    }
    function ownNode(n) {
      return n.nodeType !== 1 ? true : n.matches('[data-ok-prot]');
    }
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i], t = m.target;
        if (t.nodeType !== 1) continue;
        if (t.closest('[data-ok-prot], .cart-count-badge, .cart-drawer__title-counter, .cart__title-counter')) continue;
        if (!(t.id === 'CartDrawer-Body' || t.closest('#CartDrawer-Body') || t.closest('cart-items'))) continue;
        var nodes = Array.prototype.slice.call(m.addedNodes).concat(Array.prototype.slice.call(m.removedNodes));
        if (nodes.length && nodes.every(ownNode)) continue;
        scheduleEnsure();
        return;
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
    ensureProtection();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchCart);
  else watchCart();

  /* ==========================================================================
     PDP: "Agregar al carrito" como Milfshakes. Al tocarlo (el boton principal o el
     flotante) ambos muestran al instante tres puntitos animados y no se pueden
     volver a tocar hasta que el producto entra al carrito y se abre el carrito.
     ========================================================================== */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var main = form.querySelector('.product-form__submit');
    if (!main || main.hasAttribute('disabled')) return;
    var fid = form.getAttribute('id');
    var btns = [main];
    if (fid) document.querySelectorAll('[form="' + fid + '"]').forEach(function (b) { if (btns.indexOf(b) === -1) btns.push(b); });
    btns.forEach(function (b) { b.classList.add('ok-loading'); });
    var done = false;
    function stop() {
      if (done) return;
      done = true;
      obs.disconnect();
      clearTimeout(timer);
      btns.forEach(function (b) { b.classList.remove('ok-loading'); });
    }
    var sawBusy = false;
    var obs = new MutationObserver(function () {
      if (main.getAttribute('aria-disabled') === 'true') { sawBusy = true; return; }
      if (sawBusy) stop();
    });
    obs.observe(main, { attributes: true, attributeFilter: ['aria-disabled'] });
    var timer = setTimeout(stop, 10000);
  }, true);

  /* PDP celular: el boton flotante se oculta mientras los botones principales
     ("Agregar al carrito" / "Comprar ahora") se ven en pantalla, y reaparece al
     scrollear mas alla (igual que Milfshakes). */
  function okStickyWatch() {
    var bar = document.querySelector('.product__sticky-cart[id^="ProductStickyCart-template"]');
    var btn = bar && bar.querySelector('[form]');
    var form = btn && document.getElementById(btn.getAttribute('form'));
    var main = (form && form.querySelector('.product-form__buttons')) || document.querySelector('.product-form__buttons');
    if (!bar || !main) return;
    var mq = window.matchMedia('(max-width: 749px)');
    function check() {
      if (!mq.matches) { bar.classList.remove('ok-sticky-hide'); return; }
      var r = main.getBoundingClientRect();
      var visible = r.top < window.innerHeight + 10 && r.bottom > -10;
      bar.classList.toggle('ok-sticky-hide', visible);
    }
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
    check();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', okStickyWatch);
  else okStickyWatch();


  /* ==========================================================================
     PDP celular: selector de talle en el boton flotante. Al lado de "Agregar al
     carrito" aparece el talle elegido; al tocarlo se abre un panel desde abajo con
     los talles (los agotados tachados). Elegir uno cambia el talle de la ficha
     (mismo selector del tema), asi precio, stock y carrito quedan sincronizados.
     ========================================================================== */
  function okOptSets() {
    var all = Array.prototype.slice.call(document.querySelectorAll('product-variant-selects fieldset[data-option-name]'))
      .filter(function (f) { return !f.closest('quick-cart-drawer') && f.querySelectorAll('input[type="radio"]').length > 0; });
    /* Siempre se muestra el talle (aunque haya uno solo) para que el cliente sepa
       que se lleva. Otras opciones con un unico valor (p. ej. un solo color) no. */
    var main = all.filter(function (f) {
      return f.querySelectorAll('input[type="radio"]').length > 1 || /talle|size|tama/i.test(f.getAttribute('data-option-name') || '');
    });
    return main.length ? main : all;
  }
  function okSelectedText() {
    return okOptSets().map(function (f) {
      var c = f.querySelector('input[type="radio"]:checked');
      return c ? c.value : '';
    }).filter(Boolean).join(' · ');
  }
  function okCloseSheet() {
    var s = document.getElementById('ok-size-sheet');
    if (!s) return;
    s.classList.remove('is-open');
    document.documentElement.classList.remove('ok-sheet-lock');
    setTimeout(function () { if (s.parentNode && !s.classList.contains('is-open')) s.remove(); }, 250);
  }
  function okOpenSheet() {
    okCloseSheet();
    var sets = okOptSets();
    if (!sets.length) return;
    var html = '<div class="ok-sheet__backdrop" data-ok-sheet-close></div><div class="ok-sheet__panel" role="dialog" aria-modal="true" aria-label="Elegir talle">' +
      '<div class="ok-sheet__head"><span class="ok-sheet__title">Elegí tu talle</span>' +
      '<button type="button" class="ok-sheet__close" data-ok-sheet-close aria-label="Cerrar"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M5 5L19 19M19 5L5 19" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg></button></div>';
    sets.forEach(function (f, fi) {
      html += '<div class="ok-sheet__group"><div class="ok-sheet__label">' + (f.getAttribute('data-option-name') || '') + '</div><div class="ok-sheet__opts">';
      f.querySelectorAll('input[type="radio"]').forEach(function (inp, ii) {
        var dis = inp.disabled || inp.classList.contains('disabled');
        html += '<button type="button" class="ok-sheet__opt' + (inp.checked ? ' is-selected' : '') + (dis ? ' is-disabled' : '') + '"' +
          (dis ? ' disabled aria-disabled="true"' : '') + ' data-f="' + fi + '" data-i="' + ii + '">' +
          inp.value.replace(/</g, '&lt;') + '</button>';
      });
      html += '</div></div>';
    });
    if (document.querySelector('#Size-Guide-drawer summary')) {
      html += '<button type="button" class="ok-sheet__guide" data-ok-guide>Guía de talles</button>';
    }
    html += '</div>';
    var s = document.createElement('div');
    s.id = 'ok-size-sheet';
    s.className = 'ok-sheet';
    s.innerHTML = html;
    document.body.appendChild(s);
    document.documentElement.classList.add('ok-sheet-lock');
    requestAnimationFrame(function () { requestAnimationFrame(function () { s.classList.add('is-open'); }); });
    s.addEventListener('click', function (e) {
      if (e.target.closest('[data-ok-sheet-close]')) { okCloseSheet(); return; }
      if (e.target.closest('[data-ok-guide]')) {
        okCloseSheet();
        var sum = document.querySelector('#Size-Guide-drawer summary');
        if (sum) sum.click();
        return;
      }
      var b = e.target.closest('.ok-sheet__opt');
      if (!b || b.disabled) return;
      var f = okOptSets()[+b.getAttribute('data-f')];
      var inp = f && f.querySelectorAll('input[type="radio"]')[+b.getAttribute('data-i')];
      if (!inp) return;
      var lab = f.querySelector('label[for="' + inp.id + '"]');
      (lab || inp).click();
      okCloseSheet();
      setTimeout(okStickySizeRefresh, 50);
      setTimeout(okStickySizeRefresh, 800);
    });
  }
  function okStickySizeRefresh() {
    var action = document.querySelector('.product__sticky-cart[id^="ProductStickyCart-template"] .product__sticky-cart--action');
    if (!action) return;
    var sets = okOptSets();
    var btn = action.querySelector('.ok-sz-btn');
    if (!sets.length) { if (btn) btn.remove(); return; }
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ok-sz-btn';
      btn.innerHTML = '<span class="ok-sz-btn__k"></span><span class="ok-sz-btn__v"></span>' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      btn.addEventListener('click', okOpenSheet);
      action.insertBefore(btn, action.firstChild);
    }
    var k = sets.length === 1 ? (sets[0].getAttribute('data-option-name') || 'Talle') : 'Opción';
    var v = okSelectedText() || 'Elegir';
    var ke = btn.querySelector('.ok-sz-btn__k'), ve = btn.querySelector('.ok-sz-btn__v');
    if (ke.textContent !== k) ke.textContent = k;
    if (ve.textContent !== v) ve.textContent = v;
    var al = 'Elegir ' + k + ': ' + v;
    if (btn.getAttribute('aria-label') !== al) btn.setAttribute('aria-label', al);
  }
  function okStickySizeInit() {
    if (!document.querySelector('.product__sticky-cart[id^="ProductStickyCart-template"]')) return;
    okStickySizeRefresh();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('product-variant-selects')) setTimeout(okStickySizeRefresh, 30);
    });
    var t = null;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(okStickySizeRefresh, 60);
    }).observe(document.querySelector('.product__sticky-cart[id^="ProductStickyCart-template"]').parentNode, { childList: true, subtree: true });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') okCloseSheet(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', okStickySizeInit);
  else okStickySizeInit();
})();
